import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { finalize } from 'rxjs/operators';
import { DsLoaderService } from '@core/services/ds-loader.service';

@Injectable({
  providedIn: 'root',
})
export class DsLoaderInterceptorService implements HttpInterceptor {
  /**
   * The requests counter.
   */
  private countRequests = 0;

  /**
   * Creates an instance of DsLoaderInterceptorService.
   *
   * @param dsLoaderService the DsLoaderService
   */
  constructor(private dsLoaderService: DsLoaderService) {}

  /**
   * Intercepts http requests and manage loader when complete or error.
   *
   * @param request the outgoing request to handle
   * @param next the next interceptor in the chain, or the backend if no interceptors in the chain.
   * @returns Observable<HttpEvent<T>>
   */
  intercept<T>(request: HttpRequest<T>, next: HttpHandler): Observable<HttpEvent<T>> {
    this.dsLoaderService.setloaderState(true);
    this.incrementRequests();
    return next.handle(request).pipe(
      finalize(() => {
        this.decrementRequests();
        if (this.countRequests === 0) {
          this.dsLoaderService.setloaderState(false);
        }
      })
    );
  }

  /**
   * Increment the http requests number.
   */
  private incrementRequests() {
    this.countRequests += 1;
  }

  /**
   * Decrement the http requests number.
   */
  private decrementRequests() {
    this.countRequests -= 1;
  }
}
